import { RowDragData } from '@terminal/constants/drag-types';

export const isRowDrag = (data: unknown): data is RowDragData =>
  typeof data === 'object' &&
  data !== null &&
  'idx' in data &&
  typeof data.idx === 'number';
